export const SET_BUY_NOW_ITEM = 'SET_BUY_NOW_ITEM';
export const GET_BUY_NOW_ITEM = 'GET_BUY_NOW_ITEM';
export const REMOVE_BUY_NOW_ITEM = 'REMOVE_BUY_NOW_ITEM';
export const INIT_BUY_NOW_ITEM = 'INIT_BUY_NOW_ITEM';
